import { usePublicAPI } from "@/services/apiService";
import { SpecialtyService } from "@/services/specialtyService";
import type { Specialty } from "@/types/auth";
import useSWR from "swr";

const SPECIALTIES_KEY = "/specialties";

export const useSpecialties = () => {
  const publicApi = usePublicAPI("v2");
  const specialtyService = new SpecialtyService(publicApi);

  const { data, error, isLoading } = useSWR<Specialty[]>(
    SPECIALTIES_KEY,
    () => specialtyService.getSpecialties(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 1800000, // 30 mins
    }
  );

  return {
    specialties: data || [],
    isLoading,
    isError: error,
  };
};
